import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {}

const TimerIcon: React.FC<IProps> = (props) => {
	return (
		<svg
			width="73"
			height="73"
			viewBox="0 0 73 73"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M63.1145 40.3021C63.1145 54.9933 51.1912 66.9167 36.5 66.9167C21.8087 66.9167 9.88538 54.9933 9.88538 40.3021C9.88538 25.6108 21.8087 13.6875 36.5 13.6875C51.1912 13.6875 63.1145 25.6108 63.1145 40.3021Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M36.5 24.333V39.5413"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M27.375 6.08301H45.625"
				stroke="currentColor"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default memo(TimerIcon);
